export default "__VITE_ASSET__CLrc6oQ4__"